import { Outlet } from "react-router";
import RestrictedHeader from "./Header";
import { Box } from "@mui/material";

const RestrictedLayout = () => {
    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <RestrictedHeader />
            <Box component="main" sx={{ width: 'calc(100% - 60px)', flexGrow: 1, p: { xs: 2, sm: 3 }, backgroundColor: "#F7F7F7" }}>
                <Outlet />
            </Box>
        </Box>
    );
}

export default RestrictedLayout;